import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import api from "../lib/api";

export default function Creators() {
  const [creators, setCreators] = useState([]);
  useEffect(() => { api.get("/creators").then((r) => setCreators(r.data)).catch(() => {}); }, []);

  return (
    <div className="pti-container py-10" data-testid="creators-page">
      <header className="border-b-2 border-pti-black pb-4">
        <h1 className="font-display text-4xl sm:text-5xl font-black">Creators</h1>
        <p className="text-gray-600 mt-1">The writers, designers, and builders behind PictureThisInk.</p>
      </header>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
        {creators.map((c) => (
          <Link key={c.id} to={`/creators/${c.username}`} data-testid={`creator-${c.username}`} className="border border-gray-200 hover:border-pti-black transition-colors overflow-hidden group">
            <div className="h-24 bg-gray-100 overflow-hidden">{c.cover && <img src={c.cover} alt="" className="w-full h-full object-cover" />}</div>
            <div className="px-5 pb-5">
              <img src={c.avatar || "https://images.unsplash.com/photo-1633332755192-727a05c4013d?w=200"} alt="" className="w-16 h-16 rounded-full object-cover border-4 border-white -mt-8 bg-gray-100" />
              <div className="font-display text-xl font-bold mt-2 flex items-center gap-1 group-hover:text-pti-red transition-colors">{c.display_name}{c.verified && <CheckCircle2 size={16} className="text-pti-red" aria-label="Verified" />}</div>
              <div className="text-sm text-gray-500">@{c.username}</div>
              <p className="text-sm text-gray-600 mt-2 line-clamp-2">{c.bio}</p>
              <div className="text-xs text-gray-400 mt-3 font-semibold">{c.followers} followers · {c.article_count} articles</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
